import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";

export const graficaApi = {
  async getGraficas(ident, tipoId, interval) {
    const url = `${API_ROUTES.dataGraficas(ident, tipoId)}&interval=${interval}`;
    const response = await request(url, { method: "GET",});
    const res = await response.json();
    return res.data || [];
  },
};
